export const PersonGroupActionTypes = {
  CREATE_PERSON_GROUP: '[PERSON GROUPS] Create new',
  SET_PERSON_GROUPS: '[PERSON GROUPS] Set Person Groups',
  DELETE_PERSON_GROUP: '[PERSON GROUPS] Delete Person Group',
  UPDATE_PERSON_GROUP: '[PERSON GROUPS] Update Person Group',
  REMOVE_PROPERTY: '[PERSON GROUP - PROPERTIES] Remove Property',
  ADD_PROPERTY: '[PERSON GROUP - PROPERTIES] Add Property',
};
